const INTERNAL_EMAILS = new Set([
    'screeningeagle.com',
    'proceq.com',
    'tectusdreamlab.com',
    'getnada.com',
    'mailinator.com',
]);

const isExternalUser = (email: string) => {
    if (!email) return '0';
    return INTERNAL_EMAILS.has(email.split('@')[1]) ? '0' : '1';
};

export default isExternalUser;
